import * as v from '@badrap/valita'
import { createStorageCategory } from './storage'
import { regionSchema } from 'src/regions'

const createStorage = createStorageCategory('local', 'PREFERENCES')

export const savedLanguage = createStorage('language', v.union(v.literal('EN')))
savedLanguage.set('EN')
export const savedDarkMode = createStorage('dark_mode', v.boolean())
savedDarkMode.set(false)
export const savedHideSecret = createStorage('hide_secret', v.boolean())
savedHideSecret.set(true)
export const savedBackendRegion = createStorage('backend_region', regionSchema)

export * from './storage'
